document.addEventListener('DOMContentLoaded', function() {
    const colEles = document.querySelectorAll('.featured-col-v2 .swiper-slider');
    colEles.forEach((colEle, index) => {
        const colSlider = new Swiper(colEle, {
            slidesPerView: 1.2,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {                
                768: {
                  slidesPerView: 2.2,                  
                },
                1024: { 
                  slidesPerView: 3.5,                 
                },
            },
        })
    })
    const reviewthumbslider = new Swiper(".review-thumb-slider", {
        slidesPerView: 3,
        spaceBetween: 8,

    });

    const reviewSliderEle = document.querySelector(".review-slider");
    const reviewSlider = new Swiper(reviewSliderEle, {
        slidesPerView: 1,
        rewind: true,
        thumbs: {
            swiper: reviewthumbslider
          },
        navigation: {
            nextEl: ".review-slider .swiper-button-next",
            prevEl: ".review-slider .swiper-button-prev",
        }
    })

    const rsnext = document.querySelector(".review-slider-wrapper .swiper-button-next");
    if(rsnext) {
        rsnext.addEventListener('click', function(){
            reviewSlider.slideNext();
        })    
    }
    
    const rsprev = document.querySelector(".review-slider-wrapper .swiper-button-prev");
    if(rsprev) {
        rsprev.addEventListener('click', function(){
            reviewSlider.slidePrev();
        })
    }

    const productThumbSlider = new Swiper(".product-thumb-slider", {
        slidesPerView: 5.3,
        spaceBetween: 10, 
        breakpoints: {                
            768: {
              slidesPerView: 5.3, 
              spaceBetween: 16,                  
            }
        },
        slideToClickedSlide: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,      
    });

    const productMainSlider = new Swiper(".product-main-slider", {
        slidesPerView: 1,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        thumbs: {
            swiper: productThumbSlider
          }
    });



    // productMainSlider.controller.control = productThumbSlider;
    // productThumbSlider.controller.control = productMainSlider;
    

    var init = false;
    var swiper;
    function swiperCard() {
        if (window.innerWidth <= 768) {
            if (!init) {
                init = true;
                swiper = new Swiper(".collection-list-v2 .swiper-slider", {        
                    slidesPerView: 1.2,                                           
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                    },        
                });
            }
        } else if (init) {
            swiper.destroy();
            init = false;
        }
    }
    swiperCard();
    window.addEventListener("resize", swiperCard);  

    console.log('test')
})